"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
exports.__esModule = true;
var React = require("react");
var react_1 = require("react");
var styled_components_1 = require("styled-components");
// 選択項目コンポーネント
exports.SituationSelectOption = function (props) {
    var _a = react_1.useState(false), touching = _a[0], setTouching = _a[1];
    var selectOption = function () {
        props.onSelect(props.option);
    };
    var selected = props.selected !== null && props.selected.id === props.option.id;
    var onTouchStart = function () {
        setTouching(true);
    };
    var onTouchEnd = function () {
        setTouching(false);
    };
    return (React.createElement(SituationOption, { selected: selected, touching: touching, onClick: selectOption, onTouchStart: onTouchStart, onTouchEnd: onTouchEnd },
        React.createElement(SituationOptionIcon, null,
            React.createElement(SituationOptionIconImg, { src: "/v2/common/image/icon/presentbox.svg" })),
        React.createElement(SituationOptionName, null, props.option.name)));
};
var SituationOption = styled_components_1["default"].div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  height: 40px;\n  margin: 10px 20px;\n  font-weight: normal;\n  font-size: 16px;\n  border: solid 1px #999;\n  border-radius: 4px;\n  ", ";\n"], ["\n  height: 40px;\n  margin: 10px 20px;\n  font-weight: normal;\n  font-size: 16px;\n  border: solid 1px #999;\n  border-radius: 4px;\n  ",
    ";\n"])), function (props) {
    return props.selected
        ? "\n        background-color: orange;\n        color: white;\n    "
        : props.touching
            ? "\n        background-color: #fc9;\n        color: #777;\n    "
            : "\n        background-color: #fff;\n        color: #777;\n    ";
});
var SituationOptionIcon = styled_components_1["default"].span(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  padding: 10px 0 10px 9px;\n  float: left;\n  width: 40px;\n  height: 100%;\n"], ["\n  padding: 10px 0 10px 9px;\n  float: left;\n  width: 40px;\n  height: 100%;\n"])));
var SituationOptionIconImg = styled_components_1["default"].img(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  width: 20px;\n  height: 20px;\n"], ["\n  width: 20px;\n  height: 20px;\n"])));
var SituationOptionName = styled_components_1["default"].p(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  padding: 5px 5px 5px 40px;\n  line-height: 30px;\n  height: auto;\n"], ["\n  padding: 5px 5px 5px 40px;\n  line-height: 30px;\n  height: auto;\n"])));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
